import { render } from "./beneficiary_id_by_process.vue?vue&type=template&id=7e9ad2b6&scoped=true"
import script from "./beneficiary_id_by_process.vue?vue&type=script&lang=js"
export * from "./beneficiary_id_by_process.vue?vue&type=script&lang=js"

import "./beneficiary_id_by_process.vue?vue&type=style&index=0&id=7e9ad2b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e9ad2b6"]])

export default __exports__